import './src/main.css'
import BorderBox9 from './src/main.vue'

export default function (Vue) {
  Vue.component(BorderBox9.name, BorderBox9)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/borderBox9/index.js